// extracted by mini-css-extract-plugin
export var headerSponsors = "sponsors-module--headerSponsors--M0LDc";
export var headerSponsors__item = "sponsors-module--headerSponsors__item--gYLVG";